import React from 'react';
import styled from '../../styled';
import Text from '../text';
const Container = styled.div `
  display: inline-flex;
  align-items: center;
  padding: 0
    ${({ theme, size }) => theme.countDot.wPadding[size]};
  height: ${({ theme, size }) => theme.countDot.height[size]};
  min-width: 6px
  border: 1px solid;
  border-color: ${({ theme, backgroundColor = 'RED_600', borderColor }) => borderColor ? theme.colors[borderColor] : theme.colors[backgroundColor]};
  border-radius: ${({ theme, size }) => theme.countDot.height[size]};
  background-color: ${({ theme, backgroundColor = 'RED_600' }) => theme.colors[backgroundColor]};
`;
const CountDot = ({ lang = 'zh-hant', label, textColor = 'SNOW_100', backgroundColor = 'RED_600', borderColor, size = 'MEDIUM', fontType = 'Micro', fontWeight, }) => (React.createElement(Container, { borderColor: borderColor, backgroundColor: backgroundColor, size: size },
    React.createElement(Text, { fontType: fontType, lang: lang, color: textColor, weight: fontWeight }, label)));
export default CountDot;
//# sourceMappingURL=index.js.map